import React from 'react'
import { useCatalogStore } from '../../stores/catalogStore'

const TABS = [
  { value: null,         label: 'All' },
  { value: 'tool',       label: 'Tools' },
  { value: 'project',    label: 'Projects' },
  { value: 'process',    label: 'Processes' },
  { value: 'capability', label: 'Capabilities' },
  { value: 'insight',    label: 'Insights' },
  { value: 'goal',       label: 'Goals' },
  { value: 'impact',     label: 'Impact' },
  { value: 'resource',   label: 'Resources' },
]

// Horizontal tab bar. Clicking a tab updates the store's entry_type filter
// and triggers a fetch. "All" clears the filter (sets it to null).
export default function EntryTypeFilter() {
  const current      = useCatalogStore((s) => s.filters.entry_type)
  const setEntryType = useCatalogStore((s) => s.setEntryType)
  const fetchEntries = useCatalogStore((s) => s.fetchEntries)

  const handleClick = (value) => {
    setEntryType(value)
    fetchEntries()
  }

  return (
    <div
      className="flex flex-wrap gap-1.5 border-b border-slate-200 pb-2"
      role="tablist"
      aria-label="Filter by entry type"
    >
      {TABS.map(({ value, label }) => {
        const isActive = (value || null) === (current || null)
        return (
          <button
            key={label}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => handleClick(value)}
            className={`rounded-full px-3 py-1.5 text-xs font-medium transition ${
              isActive
                ? 'bg-accent-600 text-white shadow-sm'
                : 'bg-white text-slate-600 hover:bg-slate-100 hover:text-slate-900'
            }`}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
